import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import Disclaimers from "./Disclaimers/Disclaimers";
const ImportantInformation = (props) => (<Fragment>
		<div className="vr vr_x4">
			<h2 className="hdg">
				<FormattedMessage id="dashboard.disclaimers.header" defaultMessage="Important Information"/>
			</h2>
		</div>
		<Disclaimers {...props}/>
	</Fragment>);
export default ImportantInformation;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/ImportantInformation/ImportantInformation.tsx